module.exports = __webpack_public_path__ + "static/media/Arcade_3123.9aab9e27.jpg";